module.exports = __webpack_public_path__ + "static/DealersysOverview-1c223fc8bfec91ce2531a92e4e1c9c91.pdf";